module.exports = __webpack_public_path__ + "src/assets/games/40/FLOW0005.jpg";